import React, { useEffect, useState } from 'react';
import { useApi } from '../../api';
import { FaCarSide } from 'react-icons/fa';
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';

const VehiculoDatos = ({ form, setForm }) => {
  const [vehiculos, setVehiculos] = useState([]);
  const [mostrarTodos, setMostrarTodos] = useState(false);
  const api = useApi();

  useEffect(() => {
    const fetchVehiculos = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await api.get(`${process.env.REACT_APP_API_URL}/api/vehiculos/`);
        setVehiculos(res.data);
      } catch (err) {
        console.error('Error cargando vehículos:', err);
      }
    };

    fetchVehiculos();
  }, []);

  // Al cambiar de cliente, volvemos a aplicar el filtro por defecto
  useEffect(() => {
    setMostrarTodos(false);
  }, [form.cliente_id]);

  const vehiculosDelCliente = form.cliente_id
    ? vehiculos.filter(v => v.cliente && v.cliente.id === form.cliente_id)
    : [];

  // Si el cliente tiene un único vehículo registrado, se autocompleta
  useEffect(() => {
    if (form.cliente_id && vehiculosDelCliente.length === 1) {
      const vehiculo = vehiculosDelCliente[0];
      setForm(prev => ({
        ...prev,
        vehiculo: {
          placa: vehiculo.placa,
          marca: vehiculo.marca,
          modelo: vehiculo.modelo,
          color: vehiculo.color,
          linea: vehiculo.linea
        }
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.cliente_id, vehiculos]);

  const sinVehiculosVinculados = !!form.cliente_id && vehiculosDelCliente.length === 0;
  const usarTodos = !form.cliente_id || mostrarTodos || sinVehiculosVinculados;
  const opcionesVehiculo = usarTodos ? vehiculos : vehiculosDelCliente;

  const handleSelection = (selected) => {
    if (selected.length > 0) {
      const vehiculo = selected[0];
      setForm(prev => ({
        ...prev,
        vehiculo: {
          placa: vehiculo.placa,
          marca: vehiculo.marca,
          modelo: vehiculo.modelo,
          color: vehiculo.color,
          linea: vehiculo.linea
        }
      }));
    } else {
      setForm(prev => ({
        ...prev,
        vehiculo: {
          placa: '',
          marca: '',
          modelo: '',
          color: '',
          linea: ''
        }
      }));
    }
  };

  return (
    <div className="card card-app mb-4">
      <div className="card-header-app"><FaCarSide /> DATOS DEL VEHÍCULO</div>
      <div className="card-body">
        <Grid container spacing={2}>
          <Grid item xs={12} md={2}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
              <Typography variant="caption" sx={{ fontWeight: 600, color: '#083a94' }}>Placa</Typography>
              {form.cliente_id && !sinVehiculosVinculados && (
                <Button
                  size="small"
                  variant="text"
                  sx={{ minWidth: 0, p: 0, fontSize: '0.75rem' }}
                  onClick={() => setMostrarTodos(prev => !prev)}
                >
                  {mostrarTodos ? 'Ver solo del cliente' : 'Ver todos'}
                </Button>
              )}
            </Box>
            <Autocomplete
              id="placa"
              options={opcionesVehiculo}
              getOptionLabel={(option) => option?.placa || ''}
              value={vehiculos.find(v => v.placa === form.vehiculo.placa) || null}
              onChange={(e, newValue) => handleSelection(newValue ? [newValue] : [])}
              renderInput={(params) => (
                <TextField {...params} placeholder="Buscar por placa..." />
              )}
            />
            {sinVehiculosVinculados && (
              <Typography variant="caption" color="warning.main" component="div" sx={{ mt: 0.5 }}>
                Este cliente no tiene vehículos vinculados. Mostrando todos los vehículos.
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField label="Marca" value={form.vehiculo.marca} disabled fullWidth />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField label="Modelo" value={form.vehiculo.modelo} disabled fullWidth />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField label="Color" value={form.vehiculo.color} disabled fullWidth />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField label="Línea" value={form.vehiculo.linea} disabled fullWidth />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default VehiculoDatos;
